import { Controller } from "@hotwired/stimulus"

// Coverflow-style carousel for hero watches.
//
// Positions:
//   is-active  — center, full size, sharp
//   is-prev    — left, smaller, blurred
//   is-next    — right, smaller, blurred
//   is-prev2   — far left, even smaller, more blurred
//   is-next2   — far right, even smaller, more blurred
//   is-hidden  — invisible

const POSITIONS = ["is-active", "is-prev", "is-next", "is-prev2", "is-next2", "is-hidden"]

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.index = 0
    this.update()

    // Auto-advance every 4 seconds
    this.timer = setInterval(() => this.next(), 4000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  prev() {
    clearInterval(this.timer)
    this.index = (this.index - 1 + this.itemTargets.length) % this.itemTargets.length
    this.update()
    this.timer = setInterval(() => this.next(), 4000)
  }

  next() {
    this.index = (this.index + 1) % this.itemTargets.length
    this.update()
  }

  update() {
    const items = this.itemTargets
    const count = items.length

    items.forEach((item, i) => {
      POSITIONS.forEach(cls => item.classList.remove(cls))

      let offset = ((i - this.index) % count + count) % count
      if (offset > Math.floor(count / 2)) offset -= count

      const cls = { 0: "is-active", 1: "is-next", "-1": "is-prev", 2: "is-next2", "-2": "is-prev2" }[offset] ?? "is-hidden"
      item.classList.add(cls)
    })
  }
}
